import { InjectionToken, Signal, signal } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';

export type DocumentExtractionEventKind =
  | 'DOCUMENT_EXTRACTION_STARTED:V1'
  | 'DOCUMENT_EXTRACTION_COMPLETED:V1'
  | 'DOCUMENT_EXTRACTION_FAILED:V1';

export type DocumentExtractionConnectionState =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'reconnecting';

export interface DocumentExtractionEvent {
  readonly kind: DocumentExtractionEventKind;
  readonly extractionId: string;
  readonly documentId: string;
  readonly versionId: string;
  readonly status: string;
  readonly errorCode?: string | null;
  readonly errorMessage?: string | null;
}

export interface DocumentExtractionEventsPort {
  readonly events$: Observable<DocumentExtractionEvent>;
  readonly connectionState: Signal<DocumentExtractionConnectionState>;
}

const disconnected = signal<DocumentExtractionConnectionState>('disconnected');

export const DOCUMENT_EXTRACTION_EVENTS = new InjectionToken<DocumentExtractionEventsPort>(
  'Document extraction SSE events',
  {
    providedIn: 'root',
    factory: () => ({
      events$: EMPTY,
      connectionState: disconnected.asReadonly(),
    }),
  },
);

export function isRunningExtractionStatus(status: string | undefined | null): boolean {
  return status === 'pending' || status === 'running';
}
